import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import {
    devConfig, // Importing development configuration
    countries, // Importing countries data
    profile, // Importing user profile data
    cashDesks, // Importing cash desks data
    agentList, // Importing agent list data
} from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterFlujoCajaView.
 * @extends JetView
 */
export default class FilterFlujoCajaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5, // Margin around the left section
            id: 'a1', // Unique identifier for the left section
            rows: [
                {
                    margin: 15, // Margin around the row
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive behavior identifier
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker', // Name of the input
                            id: 'Datepicker', // Unique identifier
                            css: 'reportrange', // CSS class for styling
                            readonly: true, // Make the input read-only
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date', // Name of the input
                            id: 'Date', // Unique identifier
                            stringResult: true, // Return date as a string
                            minWidth: 200, // Minimum width of the component
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar', // Suggestion type
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select dropdown for country selection
                            name: 'CountrySelect', // Name of the input
                            id: 'CountrySelect', // Unique identifier
                            minWidth: 200, // Minimum width of the component
                            localId: 'regions:combo', // Local identifier for the component
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for options
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Another rich select dropdown for country selection
                            name: 'CountrySelect2', // Name of the input
                            minWidth: 200, // Minimum width of the component
                            localId: 'regions:combo', // Local identifier for the component
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make the input read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for options
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'text', // Text input for ticket number
                            name: 'NoTicket', // Name of the input
                            minWidth: 200, // Minimum width of the component
                            label: "<span class='icon-ticket'></span>" + _('No. Ticket'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('No. Ticket'), // Placeholder text
                            invalidMessage: _('No. Ticket is required'), // Validation message
                            type: 'number', // Input type
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            id: 'a1', // Unique identifier for the upper section
            css: 'father-container', // CSS class for styling
            height: screen.width < 500 && screen.height < 500 ? 130 : 0, // Conditional height based on screen size
            rows: [
                {
                    responsive: 'a1', // Responsive behavior identifier
                    margin: 10, // Margin around the row
                    cols: [left], // Include the left section
                },
            ],
        };
        const buttons = {
            margin: 10, // Margin around the button section
            cols: [
                {},
                {
                    view: 'button', // Button for clearing the form
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Button for submitting the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Type indicating form submission
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection from profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            // Conditional logic based on date type
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker field if needed
                            }
                        }
                        this.app.callEvent('flujoCaja:filter', [filterdata]); // Trigger filter event with data
                        $$('b5').collapse(); // Collapse the accordion section
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide', // Type of accordion section
            rows: [
                {
                    multi: true, // Allow multiple sections to be opened
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header label for the accordion
                            id: 'b5', // Unique identifier for the accordion section
                            body: {
                                padding: 10, // Padding inside the body
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            margin: 10, // Margin around the button section
            cols: [
                {},
                {
                    view: 'button', // Button for clearing the second form
                    value: _('Limpiar'), // Button label
                    width: 100, // Fixed width for the button
                    click: () => {
                        // Click event handler
                        $$('myForm2').clear(); // Clear the second form
                    },
                },
                {
                    view: 'button', // Button for submitting the second form
                    value: _('Consultar'), // Button label
                    type: 'form', // Type indicating form submission
                    width: 110, // Fixed width for the button
                    click: () => {
                        // Click event handler
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection from profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            // Conditional logic based on date type
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker field if needed
                            }
                        }
                        this.app.callEvent('flujoCaja:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };
        const accordion_section3 = {
            padding: 10, // Padding inside the accordion section
            rows: [upper_section, buttons2], // Include upper section and buttons
        };
        const accordion_section2 = {
            type: 'wide', // Type of accordion section
            rows: [
                {
                    multi: true, // Allow multiple sections to be opened
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: false, // Initial state of the accordion
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header label for the accordion
                            id: 'b5', // Unique identifier for the accordion section
                            body: {
                                padding: 10, // Padding inside the body
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const filterPopup = webix.ui({
            // Create a popup window for filters
            view: 'window', // Window component
            move: true, // Allow window to be moved
            id: 'filterPopup', // Unique identifier for the popup
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the toolbar
                    {
                        view: 'icon', // Close icon for the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position on the screen
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2', // Unique identifier for the form
                type: 'clean', // Clean type for styling
                rows: [accordion_section3], // Include accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500 // Conditional rendering based on screen size
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} form - The form object.
     */
    init(form) {
        webix.ready(function () {
            // Ensure webix is ready before executing
            if (profile.typeDate !== 2) {
                // Conditional logic based on date type
                $$('Date').hide(); // Hide date input
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language from locale service
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Attach event after rendering datepicker
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
